export const filterFacet = (mainFacet, nivaa, level, value) => {
    if(!mainFacet || !nivaa || !level || !value) {
        return false;
    }

    const filterOut = {
        "Utdanninger": {
            "niva": {
                "Universitet og høgskole": [
                ]
            },
            "studieform": {
                "Universitet og høgskole": [
                    {
                        "filterWeight": {
                            "heltid": 7,
                            "deltid": 6,
                            "Undervisning ved lærestedet": 5,
                            "Desentralisert": 4,
                            "Samlingsbasert": 3,
                            "Nettstudium": 2,                            
                            "Nettstøttet": 1,                           
                        }
                    },
                ],
            },
        },
    }


    // console.log("mainfacet",mainFacet, "nivaa",nivaa, "level",level)
    // console.log("mainfacet",mainFacet, "item",item)

    // Filtering out data that we dont want to show for different main facets and subfacets
    // console.log("removetheese:",filterOut[mainFacet][nivaa][level]);
    let removeList; 
    if (nivaa && filterOut[mainFacet][nivaa]) {
        removeList = filterOut[mainFacet][nivaa][level];
    } else {
        // removeList = filterOut[mainFacet][nivaa][facet][subFacet];
        // This means that there is nothing to filter
        return true;
    }

    if (removeList) {
        // console.log("remove value",value)
        // console.log("removelist indexof value",removeList.indexOf(value))
        if (removeList.indexOf(value) !== -1){
            return false;
        } else {
            return true;
        }
    }
};